import React, {useEffect, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Card, Grid} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useDispatch, useSelector } from "react-redux";
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import { Estados } from "./Estados";
import { ListaItems } from "./ListaItems";
import { estados } from "../../../helpers/estados";
import { bandejaLimpiar, fetchBandejaBusqueda, fetchBandejaPorEstado, fetchCantidadesBandeja } from "../../../actions/bandeja";
import { traerContactosWeb } from "../../../actions/contactosWeb/contactos";
import { useLocation } from "react-router-dom";
import {AREAS_USUARIOS} from "../../../utils/constants";

const useStyles = makeStyles({
  root:{
      width: 850,
      margin: 30,
    //   padding:20
  },
  paper: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    flex: 1,
    // marginLeft: "auto",
    // marginRight: "auto",
  },
  iconButton: {
    padding: 10,
  },
  card:{
    width:900,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 20,
  },
  title:{
    marginLeft: 20,
  },
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const HomeBandeja = (props) => {
  
    const classes = useStyles();
    const dispatch = useDispatch();
    const query=useQuery()
    const { areas, idSeccional } = useSelector((state) => state.auth);
    const esAreaUno = (areas.map(s => s.idArea === AREAS_USUARIOS.SECCIONAL))[0];
    const idArea = areas[0].idArea;
    const [ tituloBandeja, setTituloBandeja ] = useState('Ultimas recibidas');
    const [ estadoPreAfiliadoSeleccionado, setEstadoPreAfiliadoSeleccionado] = useState("");

    const [textoBuscado, setTextoBuscado] = useState( query.get("nombre") ? query.get("nombre") : "");

    const changeTituloBandejaHandler = (titulo) => {
      setTituloBandeja(titulo);
    }

    const handleSearch = () => {
      doSearch();
      setTituloBandeja("Resultado de la Busqueda");
    }

    const handleChange = (e) => {
      setTextoBuscado( e.target.value );
    }

    const handleKeyPress = e => {
      if (e.which === 13) {
        e.preventDefault();
        doSearch();
        setTituloBandeja("Resultado de la Busqueda");
      }
    }

    const doSearch = () => {
      dispatch( bandejaLimpiar() );

      if (textoBuscado !== '') {
        dispatch( fetchBandejaBusqueda(idArea, idSeccional, textoBuscado) );
      }
    }

    useEffect (() => {
      dispatch( bandejaLimpiar() );
      dispatch( fetchCantidadesBandeja( idArea, idSeccional ) );
      dispatch( fetchBandejaPorEstado ( idArea, esAreaUno ? estados.Preafiliacion_BandejaSeccional : estados.Preafiliacion_BandejaNacional, idSeccional ) );
      dispatch(traerContactosWeb());
    }, [idArea, idSeccional, esAreaUno, dispatch])

    useEffect(()=>{
      if(query.get("nombre")){
        dispatch( fetchBandejaBusqueda(idArea, idSeccional, query.get("nombre")) );
      }
      // eslint-disable-next-line
    }, [])

    return (
      <div>
        <Card className={classes.card}>
            <Grid> 
                <h1 className={classes.title}>Solicitudes</h1>
                <Estados 
                  esAreaUno={esAreaUno}
                  idArea={idArea}
                  setTextoBuscado={setTextoBuscado}
                  idSeccional={idSeccional}
                  onClickEstado={changeTituloBandejaHandler}
                  estadoPreAfiliadoHandler={setEstadoPreAfiliadoSeleccionado}
                  estadoPreAfiliadoSeleccionado={estadoPreAfiliadoSeleccionado}
                />
                <Grid container >
                    <Card className={classes.root}>  
                        <Paper component="form" className={classes.paper}>
                            <InputBase
                                className={classes.input}
                                placeholder="CUIL / Apelllido  / Nombre"
                                onChange={handleChange}
                                onKeyPress={handleKeyPress}
                                value={textoBuscado}
                            />
                            <IconButton onClick={handleSearch} className={classes.iconButton} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                        </Paper>
                    </Card>
                </Grid>  
                <ListaItems 
                  esAreaUno={esAreaUno}
                  nombreBandeja={tituloBandeja}
                  estadoPreAfiliadoHandler={setEstadoPreAfiliadoSeleccionado}
                  {...props}
                />
            </Grid>
        </Card>
      </div>
    );

};
